import { GlButton, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { launchDrawioEditor } from '../../../drawio/drawio_editor.js?vue3';
import { create } from '../../../drawio/markdown_field_editor_facade.js?vue3';
export default {
    name: 'DrawioToolbarButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        uploadsPath: {
            type: String,
            required: true
        },
        markdownPreviewPath: {
            type: String,
            required: true
        }
    },
    methods: {
        getTextArea () {
            return document.querySelector('.js-gfm-input');
        },
        launchDrawioEditor () {
            launchDrawioEditor({
                editorFacade: create({
                    uploadsPath: this.uploadsPath,
                    textArea: this.getTextArea(),
                    markdownPreviewPath: this.markdownPreviewPath
                })
            });
        }
    }
};
